export const FREE_PROMPT_ID = 'clipes-virais';
export const FREE_PROCESSING_MODE = 'automatic';
export const NO_BRAND_KIT = 'none';

export interface ProCreationSelections {
  /** Selected prompt option id (e.g. 'clipes-virais', 'outro', or a pro preset). */
  promptId: string;
  /** Selected brand kit id, or 'none'. */
  brandKitId: string;
  /** 'copilot' (pro) or 'automatic' (free). */
  processingMode: string;
  removeSilence: boolean;
}

/**
 * Submit-side guard: forces every PRO-only creation option back to its free
 * default when the user lacks pro access, so a free user can never send pro
 * values regardless of UI state (defense in depth alongside the disabled UI).
 *
 * PRO-only: non-default prompt presets + the custom "outro" prompt, brand kit,
 * the "copilot" processing mode, and remove silence. Video format is a free
 * option and is intentionally not handled here.
 */
export function sanitizeProCreationSelections(
  selections: ProCreationSelections,
  hasProAccess: boolean,
): ProCreationSelections {
  if (hasProAccess) return selections;
  return {
    promptId: FREE_PROMPT_ID,
    brandKitId: NO_BRAND_KIT,
    processingMode: FREE_PROCESSING_MODE,
    removeSilence: false,
  };
}
